import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../heading';
import Paragraph from '../paragraph';
import { APPEARANCES } from '../paragraph/constants';
import Mark from '../mark';

const ControlGroup = ({
  children = null,
  title = '',
  additionalInfo = '',
  additionalInfoAppearance = APPEARANCES.highEmphasis,
  description = '',
  descriptionHTML = '',
  required = false,
}) => (
  <div className="ws-ui-control-group">
    {title && (
      <div className="ws-ui-control-group__title">
        <Heading type="heading-6">
          {title}
          {required && <Mark appearance="danger">&nbsp;*</Mark>}
        </Heading>
        {additionalInfo && (
          <div className="ws-ui-control-group__additional-info">
            <Paragraph appearance={additionalInfoAppearance} isClipped>
              {additionalInfoAppearance === APPEARANCES.highEmphasis ? (
                <strong>{additionalInfo}</strong>
              ) : (
                additionalInfo
              )}
            </Paragraph>
          </div>
        )}
      </div>
    )}
    {(description || descriptionHTML) && (
      <div className="ws-ui-control-group__description">
        <Paragraph size="small" appearance="medium-emphasis">
          {descriptionHTML ? (
            <span
              // eslint-disable-next-line yola/react/no-danger
              dangerouslySetInnerHTML={{ __html: descriptionHTML }}
            />
          ) : (
            description
          )}
        </Paragraph>
      </div>
    )}
    {children}
  </div>
);

ControlGroup.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  additionalInfo: PropTypes.string,
  additionalInfoAppearance: PropTypes.oneOf([
    APPEARANCES.highEmphasis,
    APPEARANCES.mediumEmphasis,
    APPEARANCES.danger,
  ]),
  description: PropTypes.string,
  descriptionHTML: PropTypes.string,
  required: PropTypes.bool,
};

export default ControlGroup;
